import styled from 'styled-components';

export const StyledInvoiceContainer = styled.div`
  background-color: ${({ theme }): string => theme.colors.secondaryBackground};
  border-radius: ${({ theme }): string => theme.radii.xxl};
  margin-bottom: 16px;
  padding: 14px;
`;

export const StyledInvoiceDetail = styled.div`
  background-color: ${({ theme }): string => theme.colors.mainBackground};
  padding: 14px;
  padding-right: 0;
  width: 100%;
  border-radius: ${({ theme }): string => theme.radii.xl};
  display: flex;
  cursor: pointer;
`;

export const StyledItemIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex: 2;
  border-left: ${({ theme }): string => theme.borders[0]};
  border-color: ${({ theme }): string => theme.colors.border};
  margin-left: 16px;
`;
